
import React, { Component } from 'react';
import BsyAlertTextEdit from '../../BsyAlertTextEdit';
import { BsyUtils } from "../../../utils/Utils";
import BsyAlertQrcode from "../../BsyAlertQrcode";
import BsyDashContainer from "../BsyDashContainer";// 编辑界面-报表访问外链
import BsySelect from '../../BsySelect';
import './index.css'
class BsyDashView extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isPassPWD: !window.FX.STATIC["HASPWD"],
            isDashFull: false,
            rel: "and",
            dashConfig: {},
            allComponentDash: {},
            isLoading: true
        }
        this.dashView = React.createRef()
    }
    openPWD = () => {
        BsyAlertTextEdit({
            title: React.language('external.link.password.dash'),
            noCancel: true,
            width: 350,
            onOk: (val, t) => {
                React.axios(`${window.FX.STATIC["DTOKEN"]}/password`, { publicPwd: val }).then(() => {
                    this.setState({ isPassPWD: true }, () => {
                        this.loadDashViewData()
                        t.closeAlter();
                    });
                    return true;
                }).catch(() => {
                    return false;
                })
                return false;
            }
        })
    }

    onfullscreenchange = () => {

        let fullEl = BsyUtils.closestClass(this.dashView.current, 'BsyDashView');
        if (fullEl) {
            if (!document.fullscreenElement) {

                fullEl.classList.remove('fullScreen')
                fullEl.classList.remove('dash-theme-dark')
                // this.setState({
                //     isDashFull: false
                // })
                this.bsyDashContext && this.bsyDashContext.doResize()
            }
        }
    }

    componentDidMount() {
        window.FX.STATIC.VIP_PACK = null;
        BsyUtils.Vip._getPack();
        this.state.isPassPWD && this.loadDashViewData()
    }

    loadDashViewData() {
        const FX = window.FX;
        let e = {};
        let rel = this.state.rel
        e.appId || BsyUtils.isEmpty(FX.STATIC.APPID) || (e.appId = FX.STATIC.APPID);
        e.entryId || BsyUtils.isEmpty(FX.STATIC.ENTRYID) || (e.entryId = FX.STATIC.ENTRYID);
        e.dataId || BsyUtils.isEmpty(FX.STATIC.DATAID) || (e.dataId = FX.STATIC.DATAID);
        FX.STATIC.BACKUP && (e.isBackup = !0);
        if (BsyUtils.isEmpty(FX.STATIC.DTOKEN)) {
            if (BsyUtils.isEmpty(FX.STATIC.FTOKEN)) {
                if (BsyUtils.isEmpty(FX.STATIC.QTOKEN)) {
                    if (BsyUtils.isEmpty(FX.STATIC.RTOKEN)) {
                        if (!BsyUtils.isEmpty(FX.STATIC.ATOKEN)) {
                            e.fx_access_token = FX.STATIC.ATOKEN
                            e.fx_access_type = "app_public"
                        }
                    } else {
                        e.fx_access_token = FX.STATIC.RTOKEN;
                        e.fx_access_type = "report_public"
                    }
                } else {
                    e.fx_access_token = FX.STATIC.QTOKEN;
                    e.fx_access_type = "form_query"
                }
            } else {
                e.fx_access_token = FX.STATIC.FTOKEN;
                e.fx_access_type = "form_public"
            }
        } else {
            e.fx_access_token = FX.STATIC.DTOKEN;
            e.fx_access_type = "form_public"
        }
        e.appId = FX.STATIC.APPID;


        React.axios(`/dashboard/app/${e.appId}/entry/${FX.STATIC.ENTRYID}`, {
            appId: e.appId, entryId: e.entryId, fx_access_token: e.fx_access_token, fx_access_type: e.fx_access_type
        }).then((res) => {
            const h = res ? res.data.entry : {};
            const AllH = res ? res.data : {};
            BsyUtils.forEach(h.components, (key, value) => {
                if (BsyUtils.isObjectEmpty(value)) {
                    delete h.components[key];
                }
            })
            rel = h.rel;
            if (!h.cacheFilter) {
                //清空缓存，筛选条件模式的默认值与缓存值不一致的情况 
                let key = `ExternallinkdashFilterCache${h.appId}${h.entryId}`;
                if (BsyUtils.Store.has(key)) {
                    BsyUtils.Store.remove(key)
                }
            } else {
                let key = `ExternallinkdashFilterCache${h.appId}${h.entryId}`;
                let filter = BsyUtils.Store.get(key)
                // console.log(key)
                // console.log(filter)
                if (filter && filter.rel) {
                    rel = filter.rel;
                }
            }
            this.setState({
                dashConfig: {
                    ...h,
                    appId: h.appId,
                    entryId: h.entryId,
                    hasLazyLoad: !0,
                },
                allComponentDash: {
                    ...AllH,
                    appId: h.appId,
                    entryId: h.entryId,
                    hasLazyLoad: !0,
                },
                rel: rel,
                isLoading: false
            }, () => {
                // this.autoRefresh();
            })
        })
    }

    getDashContext = (context) => {
        this.bsyDashContext = context;
    }

    onFullDash = () => {

        let { dashConfig } = this.state
        if (dashConfig.components && !JSON.stringify(dashConfig) !== "{}") {
            var cddashConfig = Object.fromEntries(Object.entries(dashConfig.components).filter(([key1, val]) => {
                return !val['parentsId']
            }))
            dashConfig.components = cddashConfig
        }
        let fullEl = BsyUtils.closestClass(this.dashView.current, 'BsyDashView');
        if (fullEl) {
            if (fullEl.classList.contains("fullScreen")) {
                fullEl.classList.remove('fullScreen')
                fullEl.classList.remove('dash-theme-dark')
                this.setState({
                    isDashFull: false
                }, () => {
                    this.bsyDashContext && this.bsyDashContext.doResize();
                })
                window.dashSetInterval && clearInterval(window.dashSetInterval);
                this.bsyDashContext && this.bsyDashContext._dealFilter && this.bsyDashContext._dealFilter()
                // BsyUtils.exitFullscreen();
            }
            else {
                fullEl.classList.add('fullScreen')
                if (dashConfig.styles && dashConfig.styles.theme.name !== "preset_style_light_1") {

                    fullEl.classList.add('dash-theme-dark')
                }
                this.setState({
                    isDashFull: true
                }, () => {
                    this.bsyDashContext && this.bsyDashContext.doResize();
                    this.autoRefresh();
                })
                // document.removeEventListener("fullscreenchange", this.onfullscreenchange, false)
                // document.addEventListener("fullscreenchange", this.onfullscreenchange, false)
                BsyUtils.requestFullScreen(() => {
                    this.onfullscreenchange()
                    this.setState({
                        isDashFull: false
                    })
                });

            }
        }
    }

    autoRefresh = () => {
        let { dashConfig, allComponentDash } = this.state
        if (dashConfig.autoRefresh && dashConfig.autoRefresh.enabled) {
            const appId = dashConfig.appId;
            let data = [];
            let formIdList = [];
            //缓存所有表单ID 用于后续判断 刷新的逻辑
            BsyUtils.forEach(allComponentDash.entry.components, (key, val) => {
                if (!val) {
                    return;
                }
                if (!val.forms) {
                    return;
                }
                if (!val.forms[0]) {
                    return;
                }
                if (formIdList.indexOf(val.forms[0]) < 0) {
                    if (val.forms[0].indexOf("@") > -1) {
                        data.push({
                            appId: val.forms[0].split("@")[1],
                            formId: val.forms[0].split("@")[0]
                        })
                    } else {
                        data.push({
                            appId,
                            formId: val.forms[0]
                        })
                    }
                    formIdList.push(val.forms[0])
                }
            })
            let timeNum = this.state.dashConfig.autoRefresh.autoRefreshTime;
            if (this.state.dashConfig.autoRefresh.autoRefreshTime === "custom") {
                timeNum = this.state.dashConfig.autoRefresh.autoRefreshTimeNum;
            }
            React.axios("/data/get_update_time", data).then((res) => {
                this.updateTime = res.data;
                this.bsyDashContext && this.bsyDashContext._dealFilter && this.bsyDashContext._dealFilter();
                window.dashSetInterval = setInterval(() => {
                    React.axios("/data/get_update_time", data).then((res) => {
                        let flg = false;
                        for (let i = 0; i < res.data.length; i++) {
                            if (res.data[i].updateTime !== this.updateTime[i].updateTime) {
                                flg = true;
                                this.bsyDashContext && this.bsyDashContext._dealFilter && this.bsyDashContext._dealFilter(false, "isFull", res.data[i])
                            }
                        }
                        if (flg) {
                            this.updateTime = res.data;
                            if (window.dashSetInterval) {
                                clearInterval(window.dashSetInterval);
                                window.dashSetInterval = null;
                            }

                        }
                    }).catch(res => {
                        console.log(res)
                    })
                }, timeNum * 1000)
            }).catch(res => {
                console.log(res)
            })
        }

    }

    openQrcode = (event) => {
        event.stopPropagation()
        const { dashConfig } = this.state;
        const pot = event.currentTarget.getBoundingClientRect()
        let theme = ''
        if (dashConfig.styles && dashConfig.styles.theme && dashConfig.styles.theme.name) {
            theme = dashConfig.styles.theme.name
        }
        const css = 160 > (document.documentElement.clientHeight - pot.top + event.currentTarget.offsetHeight + 2) ? {
            left: pot.left - 160 + 'px',
            minWidth: event.currentTarget.offsetWidth,
            bottom: document.documentElement.clientHeight - pot.top + 2 + 'px'
        } : {
            left: pot.left - 160 + 'px',
            minWidth: event.currentTarget.offsetWidth,
            top: pot.top + event.currentTarget.offsetHeight + 2 + 'px'
        }
        BsyAlertQrcode({
            value: window.location.href,  //value参数为生成二维码的链接
            size: 160, //二维码的宽高尺寸
            css: css,
            theme: theme,
            text: React.language('msg.qrCode'),
            fgColor: (theme === "preset_style_dark_3" || theme === "preset_style_dark_1") ? "#29314c" : "#000000"
        })
    }

    onResetRel = (t) => {
        if (this.bsyDashContext && this.bsyDashContext.setRel)
            this.bsyDashContext.setRel(t);
    }

    onResetFilter = (t) => {
        this.bsyDashContext.ResetFilter();
    }

    render() {
        const { isPassPWD, isDashFull, rel, isLoading, allComponentDash } = this.state;
        let { dashConfig } = this.state;
        if (dashConfig.components && !JSON.stringify(dashConfig) !== "{}") {
            var cddashConfig = Object.fromEntries(Object.entries(dashConfig.components).filter(([key1, val]) => {
                return !val['parentsId']
            }))
            dashConfig.components = cddashConfig
        }



        const that = this;
        let theme = '';
        if (dashConfig.styles && dashConfig.styles.theme && dashConfig.styles.theme.name) {
            theme = dashConfig.styles.theme.name
        }
        let rootTokenDashClass = 'rootTokenDashClass' + window.FX.STATIC.APPID + window.FX.STATIC.ENTRYID;

        return (
            <div className="BsyDashView" >
                <div className="dashView-header">
                    <div className="dashView-name">
                        {window.FX.STATIC["DASHNAME"]}
                    </div>
                    <div className="dashView-funBtn">
                        {
                            dashConfig.showFilter ? <>

                                <div className="dash-filter-rel"
                                    data-tip={rel === 'and' ? React.language('reset.filter.and.tip') : React.language('reset.filter.or.tip')} data-place={"bottom"} data-type={window.mode} data-html={true}
                                >

                                    <BsySelect
                                        allowBlank={false}
                                        searchable={false}
                                        value={rel}
                                        theme={theme}
                                        items={[
                                            { value: "and", text: React.language('filter.rel.and'), },
                                            { value: "or", text: React.language('filter.rel.or'), }]}
                                        onStopEdit={(val) => {
                                            that.onResetRel(val)
                                        }}
                                    />

                                </div>
                            </>
                                : ''
                        }
                        {
                            dashConfig.cacheFilter ? <>
                                <div
                                    data-tip={React.language('reset.filter')} data-place={"bottom"} data-type={window.mode} data-html={true}
                                    className="dash-filter-reset" onClick={that.onResetFilter}><i className={"icon-async"} /><span>{React.language('richtext.reset')}</span></div></>
                                : ''
                        }
                        <div className="form-view Full"
                            onClick={this.onFullDash}
                            onMouseEnter={(event) => {
                                if ((this.bsyDashContext.props.autoRefresh && (this.bsyDashContext.props.autoRefresh && this.bsyDashContext.props.autoRefresh.enabled))) {
                                    window.FX.UI.showPopover({
                                        position: "bottomLeft",
                                        anchor: window.$(event.target),
                                        content: window.$("<span/>").text(React.language('dash.full.autoRefresh.tip')),
                                        type: "dark"
                                    })
                                }
                            }} onMouseLeave={() => {
                                window.FX.UI.closePopover()
                            }}
                        >
                            <i className={isDashFull ? "icon-bsy-iconsuoxiao" : "icon-bsy-iconquanping"} />
                            <span>{isDashFull ? React.language("exitfullScreen") : React.language("fullScreen")}</span>
                        </div>
                        <div className="view-qrcode" onClick={this.openQrcode}>
                            <i className="icon-qrcode"></i>
                        </div>
                    </div>
                </div>
                {
                    isPassPWD ? <div className="dashView-body" ref={this.dashView}>
                        {!isLoading && <BsyDashContainer
                            // key={`dash${dashConfig.appId}${dashConfig.entryId}`}
                            {...dashConfig}
                            allComponentDash={allComponentDash}
                            showType="dashView"
                            isDashFull={isDashFull}
                            rootTokenDashClass={rootTokenDashClass}
                            rel={rel}
                            getContext={this.getDashContext}
                            prefix={'Externallink'}
                        />}
                    </div> : this.openPWD()
                }
            </div>
        );
    }
}

export default BsyDashView;
